import { useEffect, useState } from "react";
import axiosInstant from "../../api";
import { proposalPricingPreviewEndpoint } from "../../api/endpoints";
import { ProposalDetail, ProposalPricingPreviewResponse } from "./types";

// One-shot pricing preview for a persisted proposal — fills the good/better/
// best comparison (detail pages + PDF Investment page). Non-fatal: pages
// render fine without it ("Custom quote" fallbacks).
export const useProposalDetailPreview = (detail: ProposalDetail | null) => {
    const [preview, setPreview] = useState<ProposalPricingPreviewResponse | null>(null);

    const signature = detail
        ? JSON.stringify({
            objective: detail.objective ? detail.objective.id : null,
            secondary: detail.secondary_objective ? detail.secondary_objective.id : null,
            channels: detail.channel_ids,
        })
        : null;

    useEffect(() => {
        if (!detail || !detail.objective || detail.channel_ids.length === 0) {
            setPreview(null);
            return;
        }
        let cancelled = false;
        (async () => {
            try {
                const { data } = await axiosInstant.post<ProposalPricingPreviewResponse>(
                    proposalPricingPreviewEndpoint,
                    {
                        objective_id: detail.objective!.id,
                        secondary_objective_id: detail.secondary_objective
                            ? detail.secondary_objective.id
                            : undefined,
                        channel_ids: detail.channel_ids,
                    },
                );
                if (!cancelled) setPreview(data);
            } catch {
                if (!cancelled) setPreview(null);
            }
        })();
        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [signature]);

    return preview;
};
